import { render } from "./loadings.vue?vue&type=template&id=2050f124&scoped=true"
import script from "./loadings.vue?vue&type=script&lang=js"
export * from "./loadings.vue?vue&type=script&lang=js"

import "./loadings.vue?vue&type=style&index=0&id=2050f124&scoped=true&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2050f124"]])

export default __exports__